export default __webpack_public_path__ + "static/media/404.1b9380ea.svg";